function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import AgreementStudio from "./AgreementStudio";
import { useStoreActions } from "../../contexts";
import RestfulWrapper from "../RestfulWrapper/RestfulWrapper";
export default function RelationshipDraftFetcher(props) {
  const {
    api
  } = useStoreActions();
  const {
    draftId
  } = props.match.params;
  return /*#__PURE__*/React.createElement(RestfulWrapper, {
    fetch: () => api.draft.getById(draftId),
    renderChild: _ref => {
      let {
        data
      } = _ref;
      return /*#__PURE__*/React.createElement(AgreementStudio, _extends({}, props, {
        relationshipDraft: data
      }));
    }
  });
}